import type { FC } from 'react'
import { type IconButtonProps, IconButton as MuiIconButton } from '@mui/material'

type Props = Omit<IconButtonProps, 'color'>

/**
 * `IconButton` is just a wrapper for MuiIconButton that:
 * - deprecates usage of `color` prop
 */
export const IconButton: FC<Props> = MuiIconButton
